import React, {useState} from 'react';
import styled from 'styled-components';
import {
  Title2,
  Title1,
  Headline,
  Footnote,
  Caption1,
} from '../../../components/Typography';
import OrderSubmitted from './OrderSubmitted';
import OrderAccepted from './OrderAccepted';
import OrderComplete from './OrderComplete';
import OrderOnDelivery from './OrderOnDelivery';
import OrderRefunded from './OrderRefunded';
import {
  ORDER_REFUNDED,
  ORDER_SUBMITTED,
  ORDER_ACCEPTED,
  ORDER_COMPLETE,
  ORDER_REJECTED,
  ORDER_ON_DELIVERY,
  ORDER_DELIVERED,
} from '../orderStatusTypes';
import {withStyles} from '@material-ui/core';
import Dialog from '../../../components/Dialog/Dialog';
import CloseButton from '../../../components/CloseButton/CloseButton';
import ProductPreview from './ProductPreview';
import Receipt from './Receipt';
import PaymentMethod from './PaymentMethod';
import moment from 'moment';
import {Text} from '../styles';
import Icon from './Icon';
import appConfig from '../../../../app-config';

const Wrapper = styled.div`
  display: grid;
  max-width: 367px;
`;

const OrderStatusWrapper = styled.div`
  width: 100%;
  padding-bottom: ${props => (props.delay ? '60%' : '50%')};
  background: ${props => props.theme.orderStatusBackgroundColor};
  border-radius: 10px;
  position: relative;
`;

const ContentWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px 32px;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-gap: 20px;
  background-image: ${props =>
    props.theme.orderStatusCardBackgroundImage
      ? `url(${props.theme.orderStatusCardBackgroundImage})`
      : 'none'};
  background-size: contain;

  @media (max-width: 480px) {
    padding: 8px 20px;
  }

  @media (max-width: 479px) {
    grid-gap: 0;
    display: none;
  }
`;

const Content = styled.div`
  align-self: end;

  @media (max-width: 409px) {
    align-self: initial;
  }
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 10px;
  align-items: center;
`;

const Title = styled(Title2)`
  color: ${props => props.theme.orderStatusTitleColor};
`;

const DetailsWrapper = styled.div`
  padding: 24px 24px 32px 24px;
  display: grid;
  grid-gap: 32px;
`;

const DetailWrapper = styled.div`
  display: grid;
  grid-gap: 22px;
`;

const DetailTitle = styled(Headline)`
  font-weight: 600;
  width: max-content;

  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);

    border-bottom: ${props => props.categoriesBarSelectedBorderColorWidth} solid
      ${props => props.theme.orderStatusTitleBarBorderColor};
  }
`;

const AddressWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 10px;
  align-items: center;
`;

const OrderMethodType = styled(Footnote)`
  font-weight: 600;
`;

const ReceiptWrapper = styled.div`
  // margin: auto;
  display: flex;
  justify-content: flex-end;
`;

const ContentWrapperMobile = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 20px;
  display: grid;
  grid-template-columns: auto 32px;
  grid-gap: 0px;
  background-image: ${props =>
    props.theme.orderStatusCardBackgroundImage
      ? `url(${props.theme.orderStatusCardBackgroundImage})`
      : 'none'};
  background-size: contain;

  @media (min-width: 480px) {
    display: none;
  }
`;
const NoteWraper = styled.div`
  width: 100%;
  margin: 0 5px 20px 0;
`;
const NoteLabel = styled.span`
  width: 100%;
  height: 17px;
  margin: 0 4px 15px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  color: var(--colors-basic-dark);
`;
const NoteText = styled.span`
  width: 100%;
  height: 17px;
  white-space: pre-line;
  margin: 0 0 0 4px;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.02px;
  color: var(--colors-basic-dark);
`;
const Line = styled.hr`
  width: 100%;
  color: #c1c1c1;
  margin: 0;
`;

const renderIcon = status => {
  switch (status) {
    case ORDER_SUBMITTED:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_submitted) ||
            'fa fa-check-circle'
          }
        />
      );
    case ORDER_ACCEPTED:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_accepted) ||
            'fas fa-hat-chef'
          }
        />
      );
    case ORDER_REFUNDED:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_refunded) ||
            'fas fa-exclamation-triangle'
          }
        />
      );
    case ORDER_COMPLETE:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_complete) ||
            'fas fa-store'
          }
        />
      );
    case ORDER_ON_DELIVERY:
      return (
        <Icon
          className={
            (appConfig.orderStatusIcons &&
              appConfig.orderStatusIcons.order_on_delivery) ||
            'fas fa-car-side'
          }
        />
      );
  }
};

const renderImage = status => {
  switch (status) {
    case ORDER_SUBMITTED:
      return <img src={appConfig.orderStatusImages.order_submitted} />;
    case ORDER_ACCEPTED:
      return <img src={appConfig.orderStatusImages.order_accepted} />;
    case ORDER_REFUNDED:
      return <img src={appConfig.orderStatusImages.order_refunded} />;
    case ORDER_COMPLETE:
      return <img src={appConfig.orderStatusImages.order_complete} />;
    case ORDER_ON_DELIVERY:
      return <img src={appConfig.orderStatusImages.order_on_delivery} />;
  }
};

const styles = () => ({
  scrollPaper: {},
  paper: {
    // margin: 0,
    // maxHeight: '90%',
    // overflowY: 'visible',
    // width: '640px',
    borderRadius: '10px',
  },
});

const PICK_UP = 'pickup';
const DROPOFF = 'drop_off';

const getAddress = orderStatus => {
  if (orderStatus.order_type === PICK_UP) {
    return getBusinessAddress(orderStatus.business_address);
  } else if (orderStatus.order_type === DROPOFF) {
    return getDropOffLocation(orderStatus.drop_off_location);
  } else {
    return getCustomerAddress(orderStatus.customer_address);
  }
};

const getDropOffLocation = dropOffLocation => {
  let finalDropOffLocationArr = [];
  let breaks = false;
  do {
    if (dropOffLocation.value) {
      finalDropOffLocationArr.push(dropOffLocation.value);
      dropOffLocation = {...dropOffLocation.option};
    } else breaks = true;
  } while (!breaks);

  return `${finalDropOffLocationArr.map(selection => {
    return ' ' + selection;
  })}`;
};

const getBusinessAddress = businessAddress => {
  return `${businessAddress.line1}, ${
    businessAddress.line2 ? `${businessAddress.line2},` : ''
  }    ${businessAddress.city}, ${businessAddress.state}`;
};

const getCustomerAddress = customerAddress => {
  return `${customerAddress.type ? `${customerAddress.type} ` : ''}${
    customerAddress.line2 ? `${customerAddress.line2} -` : ''
  }${customerAddress.line1}, ${customerAddress.city}, ${
    customerAddress.state
  }, ${customerAddress.zip}`;
};

const renderStatus = (status, orderStatus) => {
  switch (status) {
    case ORDER_SUBMITTED:
      return (
        <OrderSubmitted
          orderStatus={orderStatus}
          isIconShowing={appConfig.isOrderStatusIcon}
          imageShowing={
            appConfig.orderStatusImages &&
            appConfig.orderStatusImages.order_submitted
          }
          ignoreTruncateMessage={true}
        />
      );
    case ORDER_ACCEPTED:
      return (
        <OrderAccepted
          orderStatus={orderStatus}
          isIconShowing={appConfig.isOrderStatusIcon}
          imageShowing={
            appConfig.orderStatusImages &&
            appConfig.orderStatusImages.order_accepted
          }
          ignoreTruncateMessage={true}
        />
      );
    case ORDER_REFUNDED:
      return (
        <OrderRefunded
          orderStatus={orderStatus}
          isIconShowing={appConfig.isOrderStatusIcon}
          imageShowing={
            appConfig.orderStatusImages &&
            appConfig.orderStatusImages.order_refunded
          }
          ignoreTruncateMessage={true}
        />
      );
    case ORDER_COMPLETE:
      return (
        <OrderComplete
          orderStatus={orderStatus}
          isIconShowing={appConfig.isOrderStatusIcon}
          imageShowing={
            appConfig.orderStatusImages &&
            appConfig.orderStatusImages.order_complete
          }
          ignoreTruncateMessage={true}
        />
      );
    case ORDER_ON_DELIVERY:
      return (
        <OrderOnDelivery
          orderStatus={orderStatus}
          isIconShowing={appConfig.isOrderStatusIcon}
          imageShowing={
            appConfig.orderStatusImages &&
            appConfig.orderStatusImages.order_on_delivery
          }
          ignoreTruncateMessage={true}
        />
      );
  }
};

const OrderStatusModal = ({
  orderStatusModalData,
  setOrderStatusModalData,
  classes,
  isMultiple,
  currency,
  is_tip_enabled,
}) => {
  return (
    <Dialog
      open={orderStatusModalData !== null}
      classes={classes}
      onBackdropClick={() => setOrderStatusModalData(null)}
      scroll="body"
      maxWidth="sm"
    >
      {orderStatusModalData ? (
        <Wrapper>
          <OrderStatusWrapper delay={orderStatusModalData.delay}>
            <ContentWrapper>
              <TitleWrapper>
                <Title id="OrderStatusModal-Title">Order Status</Title>
                <div>
                  <CloseButton
                    id="OrderStatusModal-SetOrderStatus"
                    onClick={() => setOrderStatusModalData(null)}
                    // style={{alignSelf: 'center'}}
                  />
                </div>
              </TitleWrapper>
              <Content id="OrderStatusModal-Content">
                {renderStatus(
                  orderStatusModalData.status,
                  orderStatusModalData
                )}
              </Content>
            </ContentWrapper>
            <ContentWrapperMobile>
              <Title id="OrderStatusModal-Title-Mobile">Order Status</Title>
              <div>
                <CloseButton
                  id="OrderStatusModal-SetOrderStatus-Mobile"
                  onClick={() => setOrderStatusModalData(null)}
                  // style={{alignSelf: 'center'}}
                />
              </div>

              <div>
                {isMultiple && (
                  <div style={{marginTop: '4px'}}>
                    <Text id="OrderStatusModal-PlacedOn">Placed on:</Text>
                    <Text>
                      {moment(
                        orderStatusModalData.order_created_at,
                        'YYYY-MM-DD HH:mm:ss'
                      ).format('MMM DD, hh:mm A')}
                    </Text>
                  </div>
                )}

                <Content>
                  {renderStatus(
                    orderStatusModalData.status,
                    orderStatusModalData
                  )}
                </Content>
              </div>
              <div style={{alignSelf: 'center'}}>
                {appConfig.isOrderStatusIcon
                  ? appConfig.orderStatusImages
                    ? renderImage(orderStatusModalData.status)
                    : renderIcon(orderStatusModalData.status)
                  : null}
              </div>
            </ContentWrapperMobile>
          </OrderStatusWrapper>
          <DetailsWrapper>
            <DetailWrapper>
              <DetailTitle id="OrderStatusModal-DetailTitle">
                Order Method
              </DetailTitle>
              <AddressWrapper>
                <OrderMethodType id="OrderStatusModal-OrderMethodType">
                  {orderStatusModalData.order_type === PICK_UP
                    ? 'Picking up from: '
                    : orderStatusModalData.order_type === DROPOFF
                    ? 'Dine-in: '
                    : 'Delivery To: '}
                </OrderMethodType>
                <Caption1>{getAddress(orderStatusModalData)}</Caption1>
              </AddressWrapper>

              <AddressWrapper>
                <OrderMethodType>
                  {orderStatusModalData.order_type === PICK_UP
                    ? 'Picking up time: '
                    : orderStatusModalData.order_type === DROPOFF
                    ? 'Dine-in time: '
                    : 'Delivery time: '}
                </OrderMethodType>
                <Caption1>
                  {orderStatusModalData.isFutureOrder
                    ? moment(
                        orderStatusModalData.order_date,
                        'YYYY-MM-DD HH:mm:ss'
                      ).format('MMM DD, hh:mm A')
                    : 'As soon as possible'}
                </Caption1>
              </AddressWrapper>
            </DetailWrapper>
            <DetailWrapper>
              <DetailTitle id="OrderStatusModal-OrderSummary">
                Order Summary
              </DetailTitle>
              <ProductPreview products={orderStatusModalData.flatProducts} />
            </DetailWrapper>
            {orderStatusModalData.special_instruction && (
              <DetailWrapper>
                <DetailTitle id="OrderStatusModal-OrderSummary">
                  Order Instructions
                </DetailTitle>
                <NoteWraper>
                  <NoteLabel>Notes -</NoteLabel>
                  <NoteText>
                    {orderStatusModalData.special_instruction}
                  </NoteText>
                </NoteWraper>
                <Line size="2" />
              </DetailWrapper>
            )}
            <DetailWrapper>
              {/* <DetailTitle>Order Summary</DetailTitle> */}
              <ReceiptWrapper>
                <Receipt
                  id="OrderStatusModal-Receipt"
                  orderSummary={{
                    ...orderStatusModalData.order_summary,
                    currency: orderStatusModalData.currency
                      ? orderStatusModalData.currency
                      : currency,
                    orderMethodType: orderStatusModalData.order_type,
                    serviceFees: orderStatusModalData.service_fees,
                  }}
                  is_tip_enabled={is_tip_enabled}
                />
              </ReceiptWrapper>
            </DetailWrapper>
            {orderStatusModalData.order_summary.total > 0 ? (
              <DetailWrapper>
                <DetailTitle id="OrderStatusModal-PaymentMethod">
                  Payment Method
                </DetailTitle>
                <PaymentMethod
                  paymentMethod={orderStatusModalData.payments[0]}
                />
              </DetailWrapper>
            ) : null}
          </DetailsWrapper>
        </Wrapper>
      ) : null}
    </Dialog>
  );
};

export default withStyles(styles)(OrderStatusModal);
